const FinancialStatements = () => {
  return <div>FinancialStatements</div>;
};

export default FinancialStatements;
